export const appSettings = {
  ...(window.mySponsoredChildSettings || {}),
  urls: (window?.WVUS_ENV_VARS?.urls || {})
};

export default appSettings;